import React from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';

const TermsAndConditions = () => {
  const companyDetails = {
    name: 'Dershelas Ltd',
    address: 'Stadiou 15, 2867 Nicosia, Cyprus',
    email: 'support@learnaihub.net',
  };

  const termsData = [
    {
      id: "1",
      title: "1. Service",
      content: "We provide online courses and educational materials through our platform. The Service is provided 'as is' and 'as available' without any warranties of any kind. We reserve the right to modify, suspend, or discontinue the Service at any time without notice."
    },
    {
      id: "2", "title": "2. User Agreement",
      content: "By accessing or using the Service, you agree to be bound by these Terms and our Privacy Policy. If you disagree with any part of the terms, then you may not access the Service. You must provide accurate and complete information when creating an account."
    },
    {
      id: "3", "title": "3. Your License",
      content: "We grant you a limited, non-exclusive, non-transferable, and revocable license to access and use the Service for your personal, non-commercial educational purposes. You may not copy, modify, distribute, sell, or lease any part of our Services or included software."
    },
    {
      id: "4", "title": "4. Support Services",
      content: `Support is provided primarily via email and our dedicated support portal. You can contact ${companyDetails.name} at ${companyDetails.email}. We strive to respond to all inquiries within 24-48 business hours.`
    },
    {
      id: "5", "title": "5. Fees and Payment",
      content: "Certain aspects of the Service may be provided for a fee or other charge. If you elect to use paid aspects of the Service, you agree to the pricing and payment terms. We may add new services for additional fees and charges, or amend fees and charges for existing services, at any time in our sole discretion."
    },
    {
      id: "6", "title": "6. Cancellation",
      content: "You may cancel your subscription at any time. Cancellation will take effect at the end of your current billing cycle. You will continue to have access to the Service through the end of your billing period."
    },
    {
      id: "7", "title": "7. Refund Policy",
      list: [
        "All courses and educational content offered through this website are delivered digitally and access is typically granted immediately upon purchase. By completing a purchase, you acknowledge that immediate access affects your eligibility for a refund as described below.",
        "You may request a refund within 14 days of your initial purchase, provided that you have not substantially accessed or completed the course materials. Requests are assessed on a case-by-case basis and are not automatically guaranteed.",
        "Refund requests must be submitted in writing to support@learnaihub.net, including your order number and the reason for the request. We aim to respond to all refund requests within 5 business days.",
        "We may decline a refund request where a substantial portion of the course has been accessed or downloaded, where the request is made outside the eligible period, where the purchase was subject to a promotional or discounted rate explicitly marked as non-refundable, or where there is evidence of misuse, content sharing, or a violation of these Terms.",
        "Approved refunds will be issued to the original payment method within a reasonable timeframe, subject to the processing times of the relevant payment provider. Upon approval, access to the course materials will be revoked.",
        "Recurring subscription charges may be cancelled at any time to prevent future billing; cancellation does not itself entitle you to a refund of charges already incurred, except as set out above."
      ]
    },
    {
      id: "8", "title": "8. Right to Terminate",
      content: "We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms."
    },
    {
      id: "9", "title": "9. Your Responsibilities",
      content: "You are responsible for all activities that occur under your account. You agree not to:",
      list: [
        "Share your account credentials with third parties",
        "Use the Service for any illegal or unauthorized purpose",
        "Attempt to hack, destabilize, or adapt the Service",
        "Transmit any worms, viruses, or destructive code"
      ]
    },
    {
      id: "10", "title": "10. Suspension/Discontinuation",
      content: "We reserve the right at any time to modify or discontinue, temporarily or permanently, the Service (or any part thereof) with or without notice."
    },
    {
      id: "11", "title": "11. Dispute Resolution",
      list: [
        "If you have a complaint or dispute regarding a purchase, charge, or your use of the services, you agree to first contact us at support@learnaihub.net so that we may attempt to resolve the matter directly. We aim to acknowledge complaints within 24 hours and to reach a resolution within 5 business days.",
        "We encourage you to raise any billing concern with us directly before contacting your card issuer or payment provider, as doing so allows us to resolve the matter more quickly than a formal chargeback process.",
        "If a dispute cannot be resolved directly between you and the Company within a reasonable timeframe, either party may refer the matter to an independent mediation or alternative dispute resolution service before pursuing formal legal proceedings.",
      ]
    },
    {
      id: "12", "title": "12. Governing Law",
      list: [
        "These Terms, and any dispute or claim arising out of or in connection with them or the services provided through this website, shall be governed by and construed in accordance with the laws of Cyprus, without regard to its conflict of law provisions. The courts of Cyprus shall have exclusive jurisdiction to settle any such dispute, save as otherwise provided in the Dispute Resolution clause above.",
      ]
    },
    {
      id: "13", "title": "13. Copyright",
      content: "All content, features, and functionality are and will remain the exclusive property of the Academy and its licensors. Our trademarks and trade dress may not be used in connection with any product or service without our prior written consent."
    },
    {
      id: "14", "title": "14. Links to Other Websites",
      content: "Our Service may contain links to third-party web sites or services that are not owned or controlled by us. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third party web sites or services."
    },
    {
      id: "15", "title": "15. Trademarks",
      content: "The company name, the company logo, and all related names, logos, product and service names, designs, and slogans are trademarks of the Company or its affiliates or licensors."
    },
    {
      id: "16", "title": "16. Force Majeure",
      content: "We shall not be liable for any failure or delay in performance under these Terms resulting from acts beyond our reasonable control, including, without limitation, acts of God, war, terrorism, riots, embargoes, acts of civil or military authorities, fire, floods, accidents, strikes, or shortages of transportation facilities, fuel, energy, labor or materials."
    },
    {
      id: "17", "title": "17. Disclaimer of Warranties",
      content: "Your use of the Service is at your sole risk. The Service is provided on an \"AS IS\" and \"AS AVAILABLE\" basis. The Service is provided without warranties of any kind, whether express or implied."
    },
    {
      id: "18", "title": "18. Age Restriction",
      content: "The Service is intended only for access and use by individuals at least eighteen (18) years old. By accessing or using any of the Company, you warrant and represent that you are at least eighteen (18) years of age."
    },
    {
      id: "19", "title": "19. General Provisions",
      content: "These Terms shall be governed and construed in accordance With the Laws of Cyprus, without regard to its conflict of law provisions. Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights."
    }
  ];

  const renderDisputeResolutionItem = (item: string) => {
    const supportEmail = companyDetails.email;
    const emailIndex = item.indexOf(supportEmail);

    if (emailIndex === -1) return item;

    return (
      <>
        {item.slice(0, emailIndex)}
        <a
          href={`mailto:${supportEmail}`}
          target="_blank"
          rel="noreferrer"
          className="text-blue-600 underline hover:text-blue-800"
        >
          {supportEmail}
        </a>
        {item.slice(emailIndex + supportEmail.length)}
      </>
    );
  };

  return (
    <>
      <Header />
      
      {/* Page Background */}
      <div className="bg-[#f8f9fa] min-h-screen font-sans pt-24 pb-16">
        
        {/* Main Content Container */}
        <main className="max-w-4xl mx-auto px-6">
          
          {/* White Card */}
          <div className="bg-white rounded-[2rem] shadow-sm border border-zinc-100 p-8 md:p-14 mb-16">
            
            {/* Header Section */}
            <div className="mb-10">
              <h1 className="text-4xl md:text-5xl font-black text-[#042b1f] tracking-tight mb-4">
                Terms and Conditions
              </h1>

              <div className="h-1.5 w-12 bg-amber-400 rounded-full mb-8"></div>
              
              <div className="space-y-4 text-zinc-600 text-sm md:text-base leading-relaxed font-medium">
                <p className="font-bold text-[#042b1f]">Terms of Use</p>
                <p>Please read these Terms and Conditions carefully before using our website and services operated by {companyDetails.name}, located at {companyDetails.address}.</p>
                <p className="font-bold text-[#042b1f]">Last updated: March 18, 2026</p>
                <p>
                  These Terms apply to all visitors, users, and others who access or use the Service. By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.
                </p>
                <p>
                  For support or legal notices, contact {companyDetails.email}.
                </p>
              </div>
            </div>

            {/* Terms Content Iteration */}
            <div className="space-y-8">
              {termsData.map((term) => (
                <div key={term.id} className="space-y-3">
                  <h2 className="text-xl font-bold text-[#042b1f]">
                    {term.title}
                  </h2>
                  <p className="text-zinc-600 text-sm md:text-base leading-relaxed font-medium">
                    {term.content}
                  </p>
                  
                  {/* Render list if it exists in the data (like section 8) */}
                  {term.list && (
                    <ul className="list-disc text-zinc-600 text-sm md:text-base leading-relaxed font-medium space-y-2 pl-6">
                      {term.list.map((item, index) => (
                        <li key={index}>
                          {term.id === '11' ? renderDisputeResolutionItem(item) : item}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>

          </div>

       

        </main>
      </div>

      <Footer />
    </>
  );
};

export default TermsAndConditions;
